var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 86,
    viewBox: "0 0 71 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.8359 0V86H70.8359V0H69.8359Z",
    fill: "#E6E6E6",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8359 47.5H31.8359V56.5H22.8359V47.5H13.8359V38.5H22.8359V29.5H31.8359V38.5H40.8359M45.3359 20.5H9.33594C6.86094 20.5 4.83594 22.525 4.83594 25V61C4.83594 63.475 6.86094 65.5 9.33594 65.5H45.3359C47.8109 65.5 49.8359 63.475 49.8359 61V25C49.8359 22.525 47.8109 20.5 45.3359 20.5ZM45.3359 61H9.33594V25H45.3359V61Z",
    fill: "url(#paint0_linear_2645_7315)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2645_7315",
    x1: 4.83594,
    y1: 44.6438,
    x2: 50.2585,
    y2: 44.5868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#880000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#042449"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/Health.cb55efe35a12873f514c548515a250af.svg";
export { ForwardRef as ReactComponent };